import { ScrollView, StyleSheet, Text, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import UserListAndSearrchComp from '../../userListAndSearchComp/UserListAndSearrchComp'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import { useNavigation } from '@react-navigation/native'
import BodyFriendListSearch from './BodyFriendListSearch'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'


const FriendsListScreen = ({ hideModal }) => {

    const [friendsList, setFriendsList] = useState([])
    const [isLoading12, setIsLoading12] = useState(false)


    const navigate = useNavigation()
    const axiosPrivate = useAxiosPrivate()

    useEffect(() => {
        getUserFriends()
    }, [])

    const getUserFriends = async () => {
        setIsLoading12(true)
        await axiosPrivate.get('/friends').then((response) => {
            //console.log('FriendsList:', response.data.friends)
            //console.log('Friends-Response Headers', response)
            setFriendsList(response.data.friends)
            setIsLoading12(false)
        }).catch((error) => {
            setIsLoading12(false)
            //console.log('ERROR FRIENDS:', error)
        })

    }


    return (
        <View>
            <TopHeaderComponent headerText={"My Friends"} hideScreen={hideModal} paddingTop={20} />
            <ScrollView contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}>
                {/* <BodyViewmoreManageGiveaway /> */}
                <BodyFriendListSearch title={'FRIENDS'} number={25} friendsList={friendsList} isLoading12={isLoading12} />
            </ScrollView>
        </View>
    )
}

export default FriendsListScreen

